enum ACTION_TYPES {
    SET_KEY_DOWN_INIT = '@ORTALIOPL@SET_KEY_DOWN_INIT',
    SET_KEY_DOWN_SUCCESS = '@ORTALIOPL@SET_KEY_DOWN_SUCCESS',
    SET_SCREEN_PARAMS= '@ORTALIOPL@SET_SCREEN_PARAMS',
    SET_ITEMS_GRAPH = '@ORTALIOPL@SET_ITEMS_GRAPH',
    SET_RIGHT_TRACK = '@ORTALIOPL@SET_RIGHT_TRACK',
    SET_LEFT_TRACK = '@ORTALIOPL@SET_LEFT_TRACK',
    SET_UPPER_TRACK = '@ORTALIOPL@SET_UPPER_TRACK',
    SET_LOWER_TRACK = '@ORTALIOPL@SET_LOWER_TRACK',
}
export default ACTION_TYPES;